import tagsStore from "./tags";
import basesStore from "./bases";
export default {
  modules: {
    tagsStore,
    basesStore,
  },
};
